import type {Routes} from "@angular/router";

export const routes: Routes = [
  // Root
  {
    path: "",
    pathMatch: "full",
    loadComponent: async () => import("./sites/home/home"),
  },

  {
    path: "news",
    // Note: /news/rss is handled by the express server
    children: [
      {
        path: "",
        loadComponent: async () => import("./sites/news/news-list-or-details"),
      },
      {
        path: ":id",
        loadComponent: async () => import("./sites/news/news-list-or-details"),
        data: {
          hideFromSitemap: true, // Because params...
        },
      },
    ],
  },
  {
    path: "projects",
    loadComponent: async () => import("./sites/projects/projects-list"),
  },
  {
    path: "services",
    loadComponent: async () => import("./sites/services/offered-services-list"),
  },
  {
    path: "about-us",
    loadComponent: async () => import("./sites/about-us/about-us"),
  },
  {
    path: "contact",
    loadComponent: async () => import("./sites/contact/contact-us"),
  },
  {
    path: "imprint",
    loadComponent: async () => import("./sites/imprint/imprint"),
  },
  {
    path: "disclaimer",
    loadComponent: async () => import("./sites/disclaimer/disclaimer"),
  },
  {
    path: "privacy",
    loadComponent: async () => import("./sites/privacy/privacy"),
  },

  // Old, redirected routes
  {path: "projekte", redirectTo: "/projects", data: {hideFromSitemap: true}},
  {path: "dienstleistungen", redirectTo: "/services", data: {hideFromSitemap: true}},
  {path: "ueber-uns", redirectTo: "/about-us", data: {hideFromSitemap: true}},
  {path: "kontakt", redirectTo: "/contact", data: {hideFromSitemap: true}},
  {path: "impressum", redirectTo: "/imprint", data: {hideFromSitemap: true}},
  {path: "datenschutz", redirectTo: "/privacy", data: {hideFromSitemap: true}},
];
